<template>
<div class="chapter">
<div class="inner_page">
<p class="copyj">ACKNOWLEDGEMENTS: A special thank you to the following:<br/>My friends Rasanna Lupini, Margie Clewlow and Gay Lupini who helped me with the typing in the initial stages. Gwen Bergman who typed the first manuscript and bound it beautifully, but over the years too many alterations were made for me to be able to send it to a publisher. Vera Maroun who painstakingly typed the final draft. Theresa Mobarak, that very special aunt of mine, who played a big part in my life. We spent many happy hours with lots of giggles, trying to get my spelling correct. Thanks also for her many recipes. My children who always appreciated my cooking and gave me so much encouragement during the compiling of this book. My cousin Najla for all the help she gave me with the preparation of the food, especially the folding of the pies. Diane Peacock for all her work on the draft. Finally, John Peacock and Hilary Biller for their contribution to this book. I will always remember the fun we had whilst doing the photography.</p>
<p class="copy2">NOTE: The author has made use of quotations throughout the text. These were handed down in her family and in many cases the sources are unknown and are therefore not acknowledged.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?99b88206